import React, { useRef, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import ButtonSection from "../../component/buttonSection";
import FlatlistNews from "../../component/FlatListNews";
const { width, height } = Dimensions.get("window");
export default function index({ navigation }) {
  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorHome="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background navigation={navigation} Title="NEWS" />
          <View style={styles.viewListDetail}>
            <FlatlistNews
              InfoGuestAdmin={"InfoGuest"}
              navigation={navigation}
              onPress={() => {
                navigation.navigate("InfoGuest");
              }}
            />
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewListDetail: {
    paddingHorizontal: width * 0.04,
    paddingVertical: width * 0.03,
  },
  viewTextDetail: {
    paddingLeft: 10,
    paddingRight: 29,
    paddingTop: 5,
    paddingBottom: height * 0.03,
  },
  textTitle: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    width: width * 0.24,
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
    width: width * 0.24,
  },
});
